(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('CustomSegmentsSettingsController', CustomSegmentsSettings);


    CustomSegmentsSettings.$inject = ['ModalService', 'SettingsService'];

    function CustomSegmentsSettings(ModalService, SettingsService) {

        var vm = this;

        vm.maxSegmentsPerProvider = 450;

        vm.createdCustomSegments = SettingsService.getCreatedCustomSegments();

        vm.openManageCustomSegmentModal = function (index) {
            ModalService
                .showModal({
                    templateUrl: '../../assets/js/app/settings/modals/customsegment.manage.html',
                    controller: 'CustomSegmentManageModalController',
                    controllerAs: 'manageModal',
                    inputs: {
                        customSegment: vm.createdCustomSegments[index]
                    }
                })
                .then(function (modal) {
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result.action == 'create') {
                            vm.createdCustomSegments.push(result.customSegment);
                        }
                        else if (result.action == 'update') {
                            if (result.customSegment.public) {
                                if (angular.isDefined(result.customSegment.allowed)) result.customSegment.allowed = []
                            }

                            vm.createdCustomSegments[index] = result.customSegment;
                        }
                        SettingsService.setCreatedCustomSegments(vm.createdCustomSegments);
                    });
                });
        };

        vm.openManageSegmentCustomersModal = function (index) {
            var targetCustomSegments = index >= 0 ? [vm.createdCustomSegments[index]] : getCheckedCustomSegments('private');

            ModalService
                .showModal({
                    templateUrl: '../../assets/js/app/settings/modals/customsegmentcustomers.manage.html',
                    controller: 'CustomSegmentCustomersManageModalController',
                    controllerAs: 'segmentCustomerModal',
                    inputs: {
                        customSegments: targetCustomSegments
                    }
                })
                .then(function (modal) {
                    modal.element.modal();
                    modal.close.then(function (result) {
                        if (result.action == 'update') {
                            angular.forEach(targetCustomSegments, function (customSegment) {
                                customSegment.allowed = result.allowed;
                            });
                        }
                        SettingsService.setCreatedCustomSegments(vm.createdCustomSegments);
                    });
                });
        };

        /* -------------------------------------
         Call delete custom segment modal to confirm deleting custom segments

         ---------------------------------------*/
        //TODO: something similar is also present on campaign list. Maybe this too can be refactored in a directive
        vm.openDeleteModal = function (index) {
            ModalService
                .showModal({
                    templateUrl: '../../assets/js/app/settings/modals/customsegment.delete.html',
                    controller: 'CustomSegmentDeleteModalController',
                    controllerAs: 'deleteModal',
                    inputs: {
                        customSegmentCount: index >= 0 ? 1 : getCheckedCustomSegments().length
                    }
                })
                .then(function (modal) {
                    modal.element.modal();
                    modal.close.then(function (confirmedDelete) {
                        if (confirmedDelete) {
                            if (index >= 0) {
                                SettingsService.addDeletedCustomSegment(vm.createdCustomSegments[index]);
                                vm.createdCustomSegments.splice(index, 1);
                            }
                            else {
                                angular.forEach(checkedCustomSegments, function (customSegment) {
                                    SettingsService.addDeletedCustomSegment(customSegment);
                                    vm.createdCustomSegments.splice(_.indexOf(vm.createdCustomSegments, customSegment), 1);
                                });
                            }
                            SettingsService.setCreatedCustomSegments(vm.createdCustomSegments);
                        }
                    });
                });

        };

        //TODO: this is duplicated code (see campaign list) - ideally move to a directive and reuse
        vm.isAllChecked = function () {
            return _.every(vm.createdCustomSegments, function (customSegment) {
                return customSegment.$$checked;
            });
        };

        vm.toggleAll = function () {
            var c = vm.isAllChecked();
            _.each(vm.createdCustomSegments, function (customSegment) {
                customSegment.$$checked = !c;
            });
        };

        vm.isAnyChecked = function () {
            return _.some(vm.createdCustomSegments, function (customSegment) {
                return customSegment.$$checked;
            });
        };

        vm.isAnyPrivateChecked = function () {
            return _.some(vm.createdCustomSegments, function (customSegment) {
                return customSegment.$$checked && customSegment.public == false;
            });
        };

        vm.isMaxSegmentsAdded = function () {
            return vm.createdCustomSegments.length >= vm.maxSegmentsPerProvider;
        };

        /**
         * @param segmentScope Either 'public' or 'private'. Leave empty for 'all'.
         * @returns {*}
         */
        function getCheckedCustomSegments(segmentScope) {
            return _.filter(vm.createdCustomSegments, function (customSegment) {
                var logic = customSegment.$$checked;
                return angular.isUndefined(segmentScope) ? logic : ( segmentScope == 'public' ? logic && customSegment.public == true : logic && customSegment.public == false );
            })
        }

    }

})();